
import BlogHtmlFile from '~/components/Common/Blog/BlogHtmlFile'

export default {
    name: 'LoanTransaction',
    components: {
        BlogHtmlFile,
    },
}
